import BaseService from "../BaseService";
import { API_BASE_URL_ENV } from "../../jsx/common/common";
import http from "../HttpService";

const apiEndpoint = API_BASE_URL_ENV() + "/requests/sick-leave";

export default class SickHistoryService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}

	changeStatus(id, status) {
		return http.patch(`${apiEndpoint}/${id}/status`, { status });
	}
}
